// extracted by mini-css-extract-plugin
export default {"container":"RecurringTooltip_container__MMmmx"};